import React from 'react';
import { useLanguage, Language } from '../context/LanguageContext';

interface LanguageSelectorProps {
  onLanguageSelected: () => void;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ onLanguageSelected }) => {
  const { t, setLanguage } = useLanguage();

  const handleLanguageSelect = (language: Language) => {
    setLanguage(language);
    onLanguageSelected();
  };

  return (
    <div className="flex flex-col items-center w-full max-w-5xl mx-auto">
      <div className="text-center mb-10">
        <h1 className="text-4xl font-bold text-felco-red mb-6 tracking-tight">{t('language.select')}</h1>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-6 w-full max-w-5xl">
        <button
          onClick={() => handleLanguageSelect('en')}
          className="flex flex-col items-center p-6 border-2 border-gray-200 rounded-xl hover:border-felco-red hover:shadow-md transition-all"
        >
          <span className="text-xl font-medium">{t('language.en')}</span>
        </button>

        <button
          onClick={() => handleLanguageSelect('es')}
          className="flex flex-col items-center p-6 border-2 border-gray-200 rounded-xl hover:border-felco-red hover:shadow-md transition-all"
        >
          <span className="text-xl font-medium">{t('language.es')}</span>
        </button>
        
        <button
          onClick={() => handleLanguageSelect('fr')}
          className="flex flex-col items-center p-6 border-2 border-gray-200 rounded-xl hover:border-felco-red hover:shadow-md transition-all"
        >
          <span className="text-xl font-medium">{t('language.fr')}</span>
        </button>
        
        <button
          onClick={() => handleLanguageSelect('de')}
          className="flex flex-col items-center p-6 border-2 border-gray-200 rounded-xl hover:border-felco-red hover:shadow-md transition-all"
        >
          <span className="text-xl font-medium">{t('language.de')}</span>
        </button>
        
        <button
          onClick={() => handleLanguageSelect('nl')}
          className="flex flex-col items-center p-6 border-2 border-gray-200 rounded-xl hover:border-felco-red hover:shadow-md transition-all"
        >
          <span className="text-xl font-medium">{t('language.nl')}</span>
        </button>
        
        <button
          onClick={() => handleLanguageSelect('it')}
          className="flex flex-col items-center p-6 border-2 border-gray-200 rounded-xl hover:border-felco-red hover:shadow-md transition-all"
        >
          <span className="text-xl font-medium">{t('language.it')}</span>
        </button>
      </div>
    </div>
  );
};

export default LanguageSelector; 